import { createSlice } from "@reduxjs/toolkit";
import { set } from "zod";

 const initialState={
     queryid:"",
     bookingid:"",
     chargeableweight:"",
     volumeweight:"",
 }
const Querybookingidslice= createSlice({
    name:"Querybookingid",
    initialState,
    reducers:{
        setQueryid:(state,action)=>{
            state.queryid=action.payload
        },
        setBookingid:(state,action)=>{
            state.bookingid=action.payload
        },
        setChargeableweight:(state,action)=>{
            state.chargeableweight=action.payload
        },
        setVolumeweight:(state,action)=>{
            state.volumeweight=action.payload
        },
    }
})
export const {setQueryid,setBookingid,setChargeableweight,setVolumeweight}=Querybookingidslice.actions
export default Querybookingidslice.reducer